import React from 'react'

import { useTokenLogo } from '../utils/tokenImages.ts'
import TokenFallbackIcon from './TokenFallbackIcon.jsx'

const TokenLogoImage = ({
  address,
  chainId,
  version,
  src,
  alt = 'token logo',
  className = '',
  ...rest
}) => {
  const { logoSrc, onError } = useTokenLogo({
    address,
    chainId,
    version,
    initialUrl: src
  })

  if (!logoSrc) {
    return <TokenFallbackIcon className={className} {...rest} />
  }

  return (
    <img
      src={logoSrc}
      onError={onError}
      alt={alt}
      className={className}
      {...rest}
    />
  )
}

export default TokenLogoImage
